import './modules/swiper';
import './modules/featherlight';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import initHeaderFunctions from './modules/header-functions';
import initProductDetails from './modules/product-detail';
import initGoogleMap from './modules/google-map';
import initToggleBadges from './modules/toggle-badges';
import initCookieConsent from './modules/cookie-consent';

try {
    window.$ = window.jQuery = require('jquery');

    // Bootstrap elements example
    // require('bootstrap');
} catch (e) {
}
initHeaderFunctions();
initProductDetails();
initGoogleMap();
initToggleBadges();
initCookieConsent();
$('[faq-collapse]').collapse();

